$(document).ready(function () {

  $('.nav-toggle').click(function () {
    $('.nav-menu').toggleClass('open');
    $('.nav-toggle').toggleClass('open');
    $('html').toggleClass('no-overflow');
  });

});
